import dayjs from "dayjs";

// When a task sheet issue was reported. `date` holds the day only (the report
// form sends YYYY-MM-DD, stored as midnight UTC, i.e. 05:30 AM IST), so the
// time comes from created_at; without it only the day is shown.
const reportedAt = (issue) => issue?.created_at || issue?.createdAt;

export const formatReportedDate = (issue) =>
  dayjs(reportedAt(issue) || issue?.date).format("DD-MM-YYYY");

export const formatReportedTime = (issue) => {
  const time = reportedAt(issue);
  return time ? dayjs(time).format("hh:mm A") : "";
};

export const formatReportedAt = (issue) => {
  const time = reportedAt(issue);
  return time
    ? dayjs(time).format("DD-MM-YYYY, hh:mm A")
    : dayjs(issue?.date).format("DD-MM-YYYY");
};
